import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCGrayGraph(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 460.72 498.36">
            <g id="Statistics_concept" transform="translate(-27.09 -6.19)">
                <circle
                    id="Ellipse_9"
                    cx="228.86"
                    cy="228.86"
                    r="228.86"
                    transform="translate(28.59 7.69)"
                    fill="#fff"
                    stroke="#707171"
                    strokeMiterlimit="10"
                    strokeWidth="3"
                />
                <circle
                    id="Ellipse_10"
                    cx="36.59"
                    cy="36.59"
                    r="36.59"
                    transform="translate(197.24 96.86)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_11"
                    cx="25.48"
                    cy="25.48"
                    r="25.48"
                    transform="translate(210 107.97)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_120"
                    d="M400.89,261.38l4.1,7.12,4.1,7.13,4.12-7.11,4.13-7.11-5.68-.01.05-27.49-5.08-.01-.05,27.49Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_121"
                    d="M415.49,242.5l2.44,4.26,2.44,4.25,2.46-4.24,2.46-4.24-3.39-.01.04-16.39-3.03-.01-.03,16.39Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_122"
                    d="M136.52,96l-4.79-8.34-4.79-8.34-4.83,8.32-4.83,8.32,6.65.01-.06,32.15,5.94.01.06-32.14Z"
                    fill="#e1e1e1"
                />
                <path
                    id="Path_123"
                    d="M117.58,117.14l-2.89-5.04-2.9-5.04-2.92,5.03-2.92,5.03,4.02.01-.03,19.43,3.59.01.03-19.44Z"
                    fill="#e1e1e1"
                />
                <path
                    id="Path_124"
                    d="M418,352.65c-10.15-6.65-12.73-19.38-12.62-30.87,0-1.92-.24-3.94.64-5.65s3-2.9,4.77-2.13c1.46.63,2.13,2.27,3,3.62a11.35,11.35,0,0,0,4.66,4.19,4.41,4.41,0,0,0,4,.26c1.66-.95,1.8-3.24,1.74-5.15l-.33-10.66a17.72,17.72,0,0,1,.44-5.68,6,6,0,0,1,3.67-4.09c1.83-.55,4.13.44,4.56,2.3a17.006,17.006,0,0,1,.11,2.37,2,2,0,0,0,1.24,1.86,2.33,2.33,0,0,0,2.1-.92,25.5,25.5,0,0,0,4.45-7,35,35,0,0,1,4.12-7.19,10.48,10.48,0,0,1,7-4.09c2.76-.22,5.75,1.39,6.52,4.06s-.76,5.43-2.43,7.65a43.2,43.2,0,0,1-8.78,8.67,3.48,3.48,0,0,0-1.46,1.63c-.39,1.28.86,2.51,2.14,2.9a22.789,22.789,0,0,0,4.53.39c1.51.14,3.16.76,3.76,2.15.84,1.93-.76,4-2.35,5.39a37.089,37.089,0,0,1-10.79,6.49,12.58,12.58,0,0,0-4,2,3.48,3.48,0,0,0-1.05,4.07c.73,1.33,2.51,1.72,4,1.41a26.568,26.568,0,0,0,4.2-1.7c2.63-1.06,6.06-1,7.82,1.27a6,6,0,0,1,.78,5.32,13.869,13.869,0,0,1-2.81,4.78A37.23,37.23,0,0,1,436,351.75c-6.11,2.25-11.8,3-18,.9"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_125"
                    d="M455.17,285.34l-.18.18-.57.52c-.49.45-1.23,1.12-2.14,2a71.41,71.41,0,0,0-7.2,8c-1.4,1.8-2.84,3.83-4.36,6.05s-3.1,4.6-4.69,7.16a87,87,0,0,0-4.57,8.27c-.71,1.47-1.33,3-2,4.59s-1.29,3.16-1.94,4.78a172.057,172.057,0,0,0-6.43,18.52,83.763,83.763,0,0,0-2.84,15.73,62.512,62.512,0,0,0,.1,10.78c.13,1.27.26,2.25.37,2.91a3.776,3.776,0,0,0,.11.76v.26s-.32-1.38-.62-3.92a59.18,59.18,0,0,1-.19-10.8,83,83,0,0,1,2.78-15.79,169.523,169.523,0,0,1,6.42-18.56c.66-1.61,1.3-3.21,1.94-4.78s1.27-3.12,2-4.6a85.279,85.279,0,0,1,4.6-8.29c1.59-2.57,3.2-4.94,4.72-7.16s3-4.24,4.39-6a67.739,67.739,0,0,1,7.28-8c.93-.87,1.68-1.53,2.19-2l.58-.49Z"
                    fill="#707171"
                />
                <path
                    id="Path_126"
                    d="M431.28,317.41a4.819,4.819,0,0,1-.2-.82c-.11-.52-.24-1.29-.4-2.23-.31-1.89-.66-4.52-1-7.42s-.77-5.52-1.12-7.4c-.17-.94-.32-1.7-.44-2.23a5.535,5.535,0,0,1-.14-.82,4.483,4.483,0,0,1,.25.8c.15.51.33,1.27.53,2.21.41,1.88.83,4.5,1.21,7.4s.7,5.48.95,7.43c.13.91.23,1.66.31,2.25a4.173,4.173,0,0,1,.05.83Z"
                    fill="#e1e1e1"
                />
                <path
                    id="Path_127"
                    d="M456,312.23a.79.79,0,0,1-.25,0l-.74.08c-.63.06-1.55.16-2.69.31-2.27.29-5.39.81-8.81,1.53s-6.48,1.52-8.68,2.16c-1.1.31-2,.59-2.6.78l-.71.21a.8.8,0,0,1-.25.06,1.09,1.09,0,0,1,.23-.12l.69-.26c.6-.22,1.48-.53,2.58-.87,2.19-.69,5.25-1.51,8.68-2.24a88.751,88.751,0,0,1,8.85-1.45c1.14-.13,2.06-.19,2.7-.22h.74Z"
                    fill="#e1e1e1"
                />
                <path
                    id="Path_128"
                    d="M421.12,344.91l-.17-.29-.44-.88c-.38-.77-.9-1.89-1.53-3.28-1.26-2.78-2.89-6.68-4.63-11s-3.33-8.23-4.54-11c-.6-1.37-1.09-2.5-1.45-3.31l-.39-.9a1.249,1.249,0,0,1-.12-.33,1.52,1.52,0,0,1,.17.3l.44.88c.38.77.9,1.89,1.53,3.28,1.27,2.78,2.89,6.68,4.63,11s3.33,8.23,4.54,11c.61,1.37,1.1,2.49,1.45,3.31.16.37.29.67.4.9a1.689,1.689,0,0,1,.11.32Z"
                    fill="#e1e1e1"
                />
                <path
                    id="Path_129"
                    d="M453.88,333.62a1.289,1.289,0,0,1-.32.14l-1,.33-3.51,1.21c-3,1-7,2.48-11.54,4.1s-8.59,3.06-11.57,4c-1.49.49-2.7.87-3.54,1.12l-1,.28a1.59,1.59,0,0,1-.35.08,2.069,2.069,0,0,1,.33-.13l.95-.34,3.52-1.2c3-1,7-2.48,11.54-4.11s8.59-3.05,11.57-4c1.49-.48,2.7-.87,3.54-1.11l1-.29Z"
                    fill="#e1e1e1"
                />
                <path
                    id="Path_130"
                    d="M439,375.09c0,.13-81.07.23-181,.23s-181.08-.1-181.08-.23,81.06-.22,181.08-.22S439,375,439,375.09Z"
                    fill="#707171"
                />
                <path
                    id="Path_131"
                    d="M86.09,353.8a12.71,12.71,0,0,0-7.89-1,6.58,6.58,0,0,0-3.89,1.74c-1,1.08-1.16,3,0,3.89a3.71,3.71,0,0,0,2.45.62c2.09,0,4.4-.39,6.07.87.95.71,1.58,1.9,2.71,2.25a2.68,2.68,0,0,0,3-1.31,4.57,4.57,0,0,0,.33-3.39,5.15,5.15,0,0,0-2.78-3.67Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_132"
                    d="M91.58,343.19c-1.46,2.09-4.31,1.4-5.64.12a10.57,10.57,0,0,1-2.38-4.9c-1.17-4-2.34-8.27-1.47-12.39a6.72,6.72,0,0,1,1.58-3.36,3.58,3.58,0,0,1,3.41-1.14c1.43.38,2.33,1.79,3,3.13A29.44,29.44,0,0,1,93,337.32a10.18,10.18,0,0,1-1.39,5.87"
                    fill="#e3e2e3"
                />
                <g id="Group_2" opacity="0.2">
                    <path
                        id="Path_133"
                        d="M91.58,343.19c-1.46,2.09-4.31,1.4-5.64.12a10.57,10.57,0,0,1-2.38-4.9c-1.17-4-2.34-8.27-1.47-12.39a6.72,6.72,0,0,1,1.58-3.36,3.58,3.58,0,0,1,3.41-1.14c1.43.38,2.33,1.79,3,3.13A29.44,29.44,0,0,1,93,337.32a10.18,10.18,0,0,1-1.39,5.87"
                        fill="#e3e2e3"
                    />
                </g>
                <path
                    id="Path_134"
                    d="M95.61,346.2a7.63,7.63,0,0,1-1.18-7,13.59,13.59,0,0,1,4.15-6,22.42,22.42,0,0,1,7.44-4.39,8.06,8.06,0,0,1,3.35-.57,3.53,3.53,0,0,1,2.81,1.7c.78,1.5,0,3.31-.78,4.79a57.131,57.131,0,0,1-4.89,7.44,13.15,13.15,0,0,1-5.37,4.6c-2.24.86-4.56.76-5.74-.79"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_135"
                    d="M91.68,374.79a5.079,5.079,0,0,1-.13-1c-.07-.69-.15-1.56-.25-2.6a36,36,0,0,0-.59-3.81,28.83,28.83,0,0,0-1.38-4.49,16.37,16.37,0,0,0-2.3-4.07,8.58,8.58,0,0,0-2.9-2.42,8.151,8.151,0,0,0-2.45-.76,4,4,0,0,1-.94-.14,5,5,0,0,1,1,0,7.459,7.459,0,0,1,2.55.66,8.56,8.56,0,0,1,3.06,2.44,15.87,15.87,0,0,1,2.38,4.15,27.6,27.6,0,0,1,1.38,4.57,32.742,32.742,0,0,1,.51,3.86c.08,1.1.11,2,.12,2.61a3.76,3.76,0,0,1-.06,1Z"
                    fill="#707171"
                />
                <path
                    id="Path_136"
                    d="M91.51,372.8a1.39,1.39,0,0,1,0-.45v-5.9c-.1-3.92-.44-9.33-1.09-15.27S88.81,339.88,88,336c-.19-1-.37-1.83-.55-2.58s-.32-1.42-.46-1.95l-.29-1.23a2.739,2.739,0,0,1-.08-.43,1.59,1.59,0,0,1,.15.41l.37,1.21c.16.53.33,1.18.52,1.94s.41,1.61.61,2.57a142.818,142.818,0,0,1,2.44,15.15,151.4,151.4,0,0,1,1,15.31c0,2,0,3.56-.06,4.65,0,.52-.06.93-.08,1.27a2.35,2.35,0,0,1-.06.48Z"
                    fill="#707171"
                />
                <path
                    id="Path_137"
                    d="M91.48,362.33a8.33,8.33,0,0,1,0-1.32c.05-.84.16-2.07.4-3.57a47.7,47.7,0,0,1,1.17-5.21,45.259,45.259,0,0,1,2.17-6.16,32.75,32.75,0,0,1,6.4-10,15.438,15.438,0,0,1,1.5-1.4c.24-.2.44-.39.65-.55l.58-.4a9,9,0,0,1,1.11-.71,40,40,0,0,0-3.64,3.25,34.65,34.65,0,0,0-6.24,9.92,51.1,51.1,0,0,0-2.19,6.11,50.585,50.585,0,0,0-1.23,5.16c-.28,1.48-.43,2.7-.53,3.54a8.31,8.31,0,0,1-.15,1.34Z"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_89"
                    width="208.67"
                    height="162.37"
                    transform="translate(150.62 141.51)"
                    fill="#fff"
                />
                <path
                    id="Path_138"
                    d="M359.29,303.88c0-1.21-.06-64.36-.14-162.37l.14.15H150.64l.18-.18V303.85l-.16-.16,208.67.16L150.62,304h-.15V141.29H359.46v.14C359.35,239.52,359.29,302.67,359.29,303.88Z"
                    fill="#707171"
                />
                <path
                    id="Path_139"
                    d="M208,290.24c-.1,0-.18-17.65-.18-39.41s.08-39.42.18-39.42.18,17.64.18,39.42S208.1,290.24,208,290.24Z"
                    fill="#707171"
                />
                <path
                    id="Path_140"
                    d="M298.56,290.24c-.1,0-.18-17.65-.18-39.41s.08-39.42.18-39.42.18,17.64.18,39.42S298.66,290.24,298.56,290.24Z"
                    fill="#1a2e35"
                />
                <path
                    id="Path_141"
                    d="M238.92,290.24c-.1,0-.18-22.56-.18-50.39s.08-50.39.18-50.39.17,22.56.17,50.39S239,290.24,238.92,290.24Z"
                    fill="#707171"
                />
                <path
                    id="Path_142"
                    d="M176.25,290.24c-.1,0-.18-22.56-.18-50.39s.08-50.39.18-50.39.18,22.56.18,50.39S176.35,290.24,176.25,290.24Z"
                    fill="#707171"
                />
                <path
                    id="Path_143"
                    d="M334.1,290.24c-.1,0-.17-22.56-.17-50.39s.07-50.39.17-50.39.18,22.56.18,50.39S334.2,290.24,334.1,290.24Z"
                    fill="#707171"
                />
                <path
                    id="Path_144"
                    d="M266,290.24c-.1,0-.18-26.05-.18-58.18s.08-58.19.18-58.19.17,26,.17,58.19S266.12,290.24,266,290.24Z"
                    fill="#1a2e35"
                />
                <path
                    id="Path_145"
                    d="M208.74,211.41a.74.74,0,1,1-.74-.74.74.74,0,0,1,.74.74Z"
                    fill="#1a2e35"
                />
                <circle
                    id="Ellipse_12"
                    cx="0.74"
                    cy="0.74"
                    r="0.74"
                    transform="translate(238.18 188.72)"
                    fill="#1a2e35"
                />
                <path
                    id="Path_146"
                    d="M238.92,192.05a2.6,2.6,0,1,1,2.59-2.59,2.6,2.6,0,0,1-2.59,2.59Zm0-5a1.01,1.01,0,1,0,0-.05Z"
                    fill="#1a2e35"
                />
                <circle
                    id="Ellipse_13"
                    cx="0.74"
                    cy="0.74"
                    r="0.74"
                    transform="translate(265.29 173.13)"
                    fill="#707171"
                />
                <circle
                    id="Ellipse_14"
                    cx="0.74"
                    cy="0.74"
                    r="0.74"
                    transform="translate(297.82 211.41)"
                    fill="#707171"
                />
                <circle
                    id="Ellipse_15"
                    cx="0.74"
                    cy="0.74"
                    r="0.74"
                    transform="translate(333.38 188.72)"
                    fill="#1a2e35"
                />
                <path
                    id="Path_147"
                    d="M177,190.2a.74.74,0,1,1-.74-.74.74.74,0,0,1,.74.74Z"
                    fill="#1a2e35"
                />
                <path
                    id="Path_148"
                    d="M341.1,225.13a2.4,2.4,0,0,1-.58.19,11.415,11.415,0,0,0-1.68.57,16.21,16.21,0,0,0-5.38,4.09c-2,2.18-4,5.23-6.58,8.65a42.077,42.077,0,0,1-4.46,5.18,25.5,25.5,0,0,1-2.9,2.4,18.87,18.87,0,0,1-11.86,3.32,21.919,21.919,0,0,1-4.5-.57,11.68,11.68,0,0,1-4.36-1.91,14.18,14.18,0,0,1-3.4-3.55c-.94-1.36-1.78-2.8-2.6-4.26-1.62-2.94-3.31-5.9-5.23-8.87s-3.63-6.18-5.58-9.31a45.06,45.06,0,0,0-6.83-8.81,20.15,20.15,0,0,0-4.59-3.29,15.17,15.17,0,0,0-5.46-1.59,19.55,19.55,0,0,0-5.8.32,19.751,19.751,0,0,0-5.5,2.09,28.6,28.6,0,0,0-8.61,8,87.634,87.634,0,0,0-6.15,9.89,100.662,100.662,0,0,1-6,9.68,47.231,47.231,0,0,1-7.21,8.23,25.481,25.481,0,0,1-2.1,1.66,22.7,22.7,0,0,1-2.21,1.45,18.93,18.93,0,0,1-4.81,2,15.611,15.611,0,0,1-2.51.47,9,9,0,0,1-1.27.07h-1.25a19.66,19.66,0,0,1-4.82-.89,32.319,32.319,0,0,1-8.13-4.26c-2.42-1.66-4.63-3.38-6.79-4.94a36.219,36.219,0,0,0-6.45-3.9,21.379,21.379,0,0,0-6.41-1.83,16,16,0,0,0-5.77.38,8.669,8.669,0,0,0-1.25.4,8.492,8.492,0,0,0-1.16.46,14.611,14.611,0,0,0-2,1.13,21.239,21.239,0,0,0-3.06,2.45l-1.07,1.17a11.377,11.377,0,0,0-.85,1l-1.08,1.42a3.091,3.091,0,0,1-.4.47,2.35,2.35,0,0,1,.31-.53l1-1.49a8.559,8.559,0,0,1,.82-1l1-1.22a21.74,21.74,0,0,1,3.07-2.58,15,15,0,0,1,2.07-1.2,7.418,7.418,0,0,1,1.19-.49,8.77,8.77,0,0,1,1.28-.44,16.29,16.29,0,0,1,6-.48,21.9,21.9,0,0,1,6.63,1.8,36.771,36.771,0,0,1,6.6,3.91c2.19,1.55,4.41,3.25,6.82,4.88a32.21,32.21,0,0,0,7.94,4.09,18,18,0,0,0,4.59.82h1.18a8.05,8.05,0,0,0,1.2-.07,15,15,0,0,0,2.37-.46,21.52,21.52,0,0,0,8.71-4.93,46.61,46.61,0,0,0,7-8.07,103.166,103.166,0,0,0,5.88-9.6,88.452,88.452,0,0,1,6.21-10,29.65,29.65,0,0,1,8.93-8.32,20.22,20.22,0,0,1,11.94-2.54A16.11,16.11,0,0,1,271,208a20.932,20.932,0,0,1,4.83,3.46,45.873,45.873,0,0,1,7,9c2,3.16,3.7,6.34,5.55,9.32s3.62,6,5.22,8.93,3.21,5.79,5.69,7.55a10.86,10.86,0,0,0,4.05,1.81,22,22,0,0,0,4.33.57,19.08,19.08,0,0,0,8.05-1.28,19.73,19.73,0,0,0,3.37-1.81,23.162,23.162,0,0,0,2.84-2.3,42.5,42.5,0,0,0,4.46-5,107.5,107.5,0,0,1,6.74-8.57,15.8,15.8,0,0,1,5.61-4,9.469,9.469,0,0,1,1.74-.48A2.509,2.509,0,0,1,341.1,225.13Z"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_90"
                    width="36.38"
                    height="2.02"
                    transform="translate(175.51 159.74)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_91"
                    width="17.98"
                    height="2.02"
                    transform="translate(175.51 164.48)"
                    fill="#707171"
                />
                <path
                    id="Path_149"
                    d="M154.88,128.26h199.9a4.51,4.51,0,0,1,4.51,4.51v8.74H150.38v-8.74a4.51,4.51,0,0,1,4.5-4.51Z"
                    fill="#707171"
                />
                <path
                    id="Path_150"
                    d="M161.2,135.14a1.43,1.43,0,1,1-1.42-1.42A1.43,1.43,0,0,1,161.2,135.14Z"
                    fill="#fff"
                />
                <path
                    id="Path_151"
                    d="M167.42,135.14a1.43,1.43,0,1,1-1.42-1.42,1.43,1.43,0,0,1,1.42,1.42Z"
                    fill="#fff"
                />
                <path
                    id="Path_152"
                    d="M173.65,135.14a1.43,1.43,0,1,1-1.43-1.42,1.43,1.43,0,0,1,1.43,1.42Z"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_92"
                    width="85.68"
                    height="24.02"
                    rx="2.19"
                    transform="translate(70.16 237.06)"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_153"
                    d="M88.22,253.08a5.22,5.22,0,1,1-.81-7.34,5.22,5.22,0,0,1,.81,7.34Z"
                    fill="#fff"
                />
                <path
                    id="Path_154"
                    d="M87.08,248a24.339,24.339,0,0,1-2.83,3l-.69.67-.12.11-.12-.12a16.221,16.221,0,0,1-2.11-2.35,16.56,16.56,0,0,1,2.36,2.11h-.25l.69-.67A23.3,23.3,0,0,1,87.08,248Z"
                    fill="#707171"
                />
                <path
                    id="Path_155"
                    d="M147.48,247.31c0,.1-10.9.18-24.33.18s-24.33-.08-24.33-.18,10.89-.18,24.33-.18S147.48,247.21,147.48,247.31Z"
                    fill="#707171"
                />
                <path
                    id="Path_156"
                    d="M127.52,252.06c0,.1-6.3.18-14.06.18s-14.06-.08-14.06-.18,6.29-.18,14.06-.18S127.52,252,127.52,252.06Z"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_93"
                    width="84.47"
                    height="35.08"
                    rx="2.62"
                    transform="translate(95.45 179.18)"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_157"
                    d="M113,190.26a3.94,3.94,0,1,1-3.94-3.93,3.94,3.94,0,0,1,3.94,3.93Z"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_94"
                    width="27.44"
                    height="1.52"
                    transform="translate(116.94 187.54)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_95"
                    width="53.38"
                    height="1.52"
                    transform="translate(116.94 191)"
                    fill="#fff"
                />
                <path
                    id="Path_158"
                    d="M113,202.37a3.94,3.94,0,1,1-3.94-3.94A3.94,3.94,0,0,1,113,202.37Z"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_96"
                    width="14.01"
                    height="1.52"
                    transform="translate(116.94 199.65)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_97"
                    width="53.38"
                    height="1.52"
                    transform="translate(116.94 203.11)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_98"
                    width="108.99"
                    height="46.32"
                    rx="2.69"
                    transform="translate(110.33 271.43)"
                    fill="#707171"
                />
                <path
                    id="Path_159"
                    d="M130.27,293.82l-.06-9.4a12,12,0,0,0-7.75,3,11.13,11.13,0,0,0-3.74,9.73,13.442,13.442,0,0,0,.22,1.37h0L130.27,296Z"
                    fill="#fff"
                />
                <path
                    id="Path_160"
                    d="M141.94,290.92a11.14,11.14,0,0,0-9.14-6.39h-1.33l.06,9.39v2.21l11.32,2.47h0a11.75,11.75,0,0,0,.25-2.44,12.24,12.24,0,0,0-1.16-5.24Z"
                    fill="#f4f5f6"
                />
                <g id="Group_3" opacity="0.2">
                    <path
                        id="Path_161"
                        d="M141.94,290.92a11.14,11.14,0,0,0-9.14-6.39h-1.33l.06,9.39v2.21l11.32,2.47h0a11.75,11.75,0,0,0,.25-2.44,12.24,12.24,0,0,0-1.16-5.24Z"
                        fill="#f4f5f6"
                    />
                </g>
                <path
                    id="Path_162"
                    d="M130.88,297.2l-11.32,2.55a11.61,11.61,0,0,0,22.66-.08l-11.33-2.47"
                    fill="#e3e2e3"
                />
                <g id="Group_4" opacity="0.1">
                    <path
                        id="Path_163"
                        d="M130.88,297.2l-11.32,2.55a11.61,11.61,0,0,0,22.66-.08l-11.33-2.47"
                        fill="#e3e2e3"
                    />
                </g>
                <rect
                    id="Rectangle_99"
                    width="57.52"
                    height="2.61"
                    transform="translate(150.73 287.23)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_100"
                    width="57.52"
                    height="2.61"
                    transform="translate(150.73 294.1)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_101"
                    width="31.09"
                    height="2.61"
                    transform="translate(150.73 301.7)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_102"
                    width="113.64"
                    height="109.41"
                    rx="8.41"
                    transform="translate(237.38 238.58)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_103"
                    width="3.73"
                    height="1.07"
                    transform="translate(245.32 313.54)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_104"
                    width="4.77"
                    height="1.07"
                    transform="translate(253.75 319.28)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_105"
                    width="4.77"
                    height="1.07"
                    transform="translate(270.36 319.28)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_106"
                    width="4.77"
                    height="1.07"
                    transform="translate(286.96 319.28)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_107"
                    width="4.77"
                    height="1.07"
                    transform="translate(303.57 319.28)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_108"
                    width="4.77"
                    height="1.07"
                    transform="translate(320.17 319.28)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_109"
                    width="4.77"
                    height="1.07"
                    transform="translate(336.77 319.28)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_110"
                    width="3.73"
                    height="1.07"
                    transform="translate(245.32 299.18)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_111"
                    width="3.73"
                    height="1.07"
                    transform="translate(245.32 272.17)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_112"
                    width="3.73"
                    height="1.07"
                    transform="translate(245.32 258.59)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_113"
                    width="3.73"
                    height="1.07"
                    transform="translate(245.51 285.68)"
                    fill="#707171"
                />
                <path
                    id="Path_164"
                    d="M341.41,314.61h-6.09l-16.59.06-54.76.05H250.82v-.18c0-18.31,0-34.42.06-46,0-5.76,0-10.38.05-13.58v0c0,3.2,0,7.82.06,13.58,0,11.55,0,27.66.06,46l-.18-.17h13l54.76.05,16.59.05H341Z"
                    fill="#707171"
                />
                <path
                    id="Path_165"
                    d="M342.46,286.21c0,.1-19.67.18-43.93.18s-43.93-.08-43.93-.18,19.67-.17,43.93-.17S342.46,286.12,342.46,286.21Z"
                    fill="#707171"
                />
                <path
                    id="Path_166"
                    d="M342.46,272.7c0,.1-19.67.18-43.93.18s-43.93-.08-43.93-.18,19.67-.17,43.93-.17S342.46,272.61,342.46,272.7Z"
                    fill="#707171"
                />
                <path
                    id="Path_167"
                    d="M342.46,259.13c0,.1-19.67.17-43.93.17s-43.93-.07-43.93-.17,19.67-.18,43.93-.18S342.46,259,342.46,259.13Z"
                    fill="#707171"
                />
                <path
                    id="Path_168"
                    d="M342.46,299.72c0,.1-19.67.18-43.93.18s-43.93-.08-43.93-.18,19.67-.18,43.93-.18S342.46,299.62,342.46,299.72Z"
                    fill="#1a2e35"
                />
                <path
                    id="Path_169"
                    d="M255.51,311.71v-12l7.47-11.6L268,292l10.41-16.16,6.13,4.32,8.54-14.91,6.94,5.65,10.4-19.77,11.21,22.1,9.07-11.06,10.67-3.05V311.7Z"
                    fill="#fff"
                />
                <path
                    id="Path_170"
                    d="M342.46,254.87h-2.91l-8.19.05h.08c-2.39,3.12-5.36,7-8.77,11.47l-.05.06H300.55l.15-.09-9.24,15.38-9.06,15.07-.14.22-.15-.2-11.9-16.37h.24l-10.86,16.91-3,4.67-.81,1.22c-.18.28-.28.41-.28.41a4.145,4.145,0,0,1,.25-.43l.76-1.24,3-4.72,10.76-17,.11-.18.12.17,11.95,16.34h-.29c2.88-4.78,5.92-9.85,9.06-15.08l9.25-15.37.05-.08h22.09l-.11.05,8.84-11.42h11.15Z"
                    fill="#707171"
                />
                <path
                    id="Path_171"
                    d="M274,284.26a.85.85,0,1,1-.84-.81.83.83,0,0,1,.84.81Z"
                    fill="#1a2e35"
                />
                <path
                    id="Path_172"
                    d="M299.3,269.86a.85.85,0,1,1-.84-.82.83.83,0,0,1,.84.82Z"
                    fill="#1a2e35"
                />
                <path
                    id="Path_173"
                    d="M319,266.32a.85.85,0,1,1-.84-.81.83.83,0,0,1,.84.81Z"
                    fill="#1a2e35"
                />
                <ellipse
                    id="Ellipse_16"
                    cx="5.45"
                    cy="5.25"
                    rx="5.45"
                    ry="5.25"
                    transform="translate(253.76 328.39)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_114"
                    width="64.03"
                    height="1.96"
                    transform="translate(272.74 330.13)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_115"
                    width="26.59"
                    height="1.96"
                    transform="translate(272.74 335.04)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_116"
                    width="75.45"
                    height="62.58"
                    rx="4.94"
                    transform="translate(314.44 153.6)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_117"
                    width="4.07"
                    height="30.71"
                    transform="translate(327.6 178.65)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_118"
                    width="4.07"
                    height="33.2"
                    transform="translate(346.09 176.16)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_119"
                    width="4.07"
                    height="37.41"
                    transform="translate(365.24 171.94)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_120"
                    width="4.07"
                    height="14.95"
                    transform="translate(356.24 194.41)"
                    fill="#707171"
                />
                <g id="Group_5" opacity="0.2">
                    <rect
                        id="Rectangle_121"
                        width="4.07"
                        height="14.95"
                        transform="translate(356.24 194.41)"
                        fill="#707171"
                    />
                </g>
                <rect
                    id="Rectangle_122"
                    width="4.07"
                    height="34"
                    transform="translate(332.34 175.36)"
                    fill="#f4f5f6"
                />
                <g id="Group_6" opacity="0.1">
                    <rect
                        id="Rectangle_123"
                        width="4.07"
                        height="34"
                        transform="translate(332.34 175.36)"
                        fill="#f4f5f6"
                    />
                </g>
                <rect
                    id="Rectangle_124"
                    width="4.07"
                    height="41.12"
                    transform="translate(351.16 168.24)"
                    fill="#f4f5f6"
                />
                <g id="Group_7" opacity="0.1">
                    <rect
                        id="Rectangle_125"
                        width="4.07"
                        height="41.12"
                        transform="translate(351.16 168.24)"
                        fill="#f4f5f6"
                    />
                </g>
                <rect
                    id="Rectangle_126"
                    width="4.07"
                    height="41.12"
                    transform="translate(375.73 168.24)"
                    fill="#707171"
                />
                <g id="Group_8" opacity="0.2">
                    <rect
                        id="Rectangle_127"
                        width="4.07"
                        height="41.12"
                        transform="translate(375.73 168.24)"
                        fill="#707171"
                    />
                </g>
                <rect
                    id="Rectangle_128"
                    width="4.07"
                    height="49.24"
                    transform="translate(370.42 160.12)"
                    fill="#f4f5f6"
                />
                <g id="Group_9" opacity="0.1">
                    <rect
                        id="Rectangle_129"
                        width="4.07"
                        height="49.24"
                        transform="translate(370.42 160.12)"
                        fill="#f4f5f6"
                    />
                </g>
                <rect
                    id="Rectangle_130"
                    width="4.07"
                    height="21.58"
                    transform="translate(337.32 187.78)"
                    fill="#707171"
                />
                <g id="Group_10" opacity="0.2">
                    <rect
                        id="Rectangle_131"
                        width="4.07"
                        height="21.58"
                        transform="translate(337.32 187.78)"
                        fill="#707171"
                    />
                </g>
                <path
                    id="Path_174"
                    d="M385.61,211.22c0,.1-14.51.18-32.41.18s-32.42-.08-32.42-.18,14.52-.17,32.42-.17S385.61,211.12,385.61,211.22Z"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_132"
                    width="2.48"
                    height="0.82"
                    transform="translate(318.9 203.9)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_133"
                    width="2.48"
                    height="0.82"
                    transform="translate(318.9 192.97)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_134"
                    width="2.48"
                    height="0.82"
                    transform="translate(318.9 172.4)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_135"
                    width="2.48"
                    height="0.82"
                    transform="translate(318.9 162.07)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_136"
                    width="2.48"
                    height="0.82"
                    transform="translate(319.03 182.69)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_137"
                    width="77.39"
                    height="21.7"
                    rx="2.19"
                    transform="translate(227.55 148.51)"
                    fill="#707171"
                />
                <path
                    id="Path_175"
                    d="M243.86,163a4.72,4.72,0,1,1-.73-6.63,4.72,4.72,0,0,1,.73,6.63Z"
                    fill="#fff"
                />
                <path
                    id="Path_176"
                    d="M240.17,164.76a4.73,4.73,0,0,1-.5-9.44,4.534,4.534,0,0,1,.52,0,4.74,4.74,0,0,1,3.69,7.7h0a4.78,4.78,0,0,1-3.71,1.77Zm0-9.43a4.53,4.53,0,0,0-.52,0,4.61,4.61,0,0,0-3.15,1.73,4.7,4.7,0,0,0,7.33,5.88h0a4.7,4.7,0,0,0-3.66-7.64Z"
                    fill="#1a2e35"
                />
                <path
                    id="Path_177"
                    d="M242.83,158.43a19.47,19.47,0,0,1-2.54,2.72l-.62.6-.12.12-.12-.12a13.331,13.331,0,0,1-1.9-2.14,13.33,13.33,0,0,1,2.14,1.9h-.24l.62-.61a19.9,19.9,0,0,1,2.78-2.47Z"
                    fill="#707171"
                />
                <path
                    id="Path_178"
                    d="M297.39,157.77c0,.1-9.84.18-22,.18s-22-.08-22-.18,9.84-.18,22-.18S297.39,157.67,297.39,157.77Z"
                    fill="#fff"
                />
                <path
                    id="Path_179"
                    d="M279.36,162.06c0,.1-5.68.18-12.7.18s-12.7-.08-12.7-.18,5.69-.18,12.7-.18S279.36,162,279.36,162.06Z"
                    fill="#fff"
                />
                <path
                    id="Path_180"
                    d="M438.29,159.16l-.28.32c-.2.21-.47.53-.87.92a16.39,16.39,0,0,1-3.93,2.74,11.77,11.77,0,0,1-1.52.65l-.83.3-.9.24a17.858,17.858,0,0,1-1.93.37c-.34,0-.69.05-1,.08a7.711,7.711,0,0,1-1.08,0,16.41,16.41,0,0,1-9.28-3h.11l-8.07,1.56-.45.09.3-.35L413,158v.21a18.431,18.431,0,0,1-2-3.54,17.681,17.681,0,0,1-1.08-4.07,16.272,16.272,0,1,1,32.27.01,16.1,16.1,0,0,1-1.49,4.92l-.46.89c-.15.27-.32.51-.47.74a8.942,8.942,0,0,1-.79,1.13l-.54.65a1.466,1.466,0,0,1-.19.22,1.585,1.585,0,0,1,.16-.24c.13-.17.3-.39.51-.68a9.124,9.124,0,0,0,.76-1.13c.14-.23.31-.47.46-.75s.28-.58.43-.89a16,16,0,0,0,.83-11.57,15.81,15.81,0,0,0-4.2-6.9,16,16,0,0,0-26.96,13.57,17.16,17.16,0,0,0,1.05,4,16.74,16.74,0,0,0,1.94,3.47l.07.11-.08.1-4.46,5.11-.15-.27,8.08-1.52h.11a16.11,16.11,0,0,0,9.11,3,7.63,7.63,0,0,0,1.07,0,4.058,4.058,0,0,0,1-.08,15.6,15.6,0,0,0,1.92-.35l.88-.22.83-.29a13,13,0,0,0,1.5-.63,16.659,16.659,0,0,0,3.95-2.66c.41-.37.69-.68.9-.88S438.29,159.16,438.29,159.16Z"
                    fill="#707171"
                />
                <path
                    id="Path_181"
                    d="M426.3,145.16l-2.73-.91-2.72-.9.58,2.81.58,2.82,1.48-1.32,6.38,7.17,1.33-1.18-6.39-7.17Z"
                    fill="#707171"
                />
                <circle
                    id="Ellipse_17"
                    cx="6.87"
                    cy="6.87"
                    r="6.87"
                    transform="translate(351.84 90.16)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_18"
                    cx="12.6"
                    cy="12.6"
                    r="12.6"
                    transform="translate(319.33 65.32)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_19"
                    cx="18.67"
                    cy="18.67"
                    r="18.67"
                    transform="translate(193.37 392.68)"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_20"
                    cx="13.01"
                    cy="13.01"
                    r="13.01"
                    transform="translate(219.25 410.73)"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_182"
                    d="M368.38,406h-9v-9a1.12,1.12,0,0,0-1.11-1.12h0a1.16,1.16,0,0,0-1.15,1.12v9h-9a1.15,1.15,0,0,0-1.13,1.15,1.12,1.12,0,0,0,1.13,1.11h9v9a1.16,1.16,0,0,0,1.15,1.12,1.12,1.12,0,0,0,1.11-1.12h0v-9h9a1.12,1.12,0,0,0,1.13-1.11,1.15,1.15,0,0,0-1.13-1.15Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_183"
                    d="M462.68,202.12h-7.82v-7.81a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v7.81h-7.8a1,1,0,1,0,0,2h7.8v7.82a1,1,0,1,0,2,0h0v-7.82h7.82a1,1,0,1,0,0-2Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_184"
                    d="M195.56,73.85h-7.82V66a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v7.81H178a1,1,0,0,0,0,2h7.8v7.82a1,1,0,0,0,2,0h0V75.82h7.82a1,1,0,0,0,0-2Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <ellipse
                    id="_Path_"
                    cx="148.28"
                    cy="14.56"
                    rx="148.28"
                    ry="14.56"
                    transform="translate(109.76 475.43)"
                    fill="#f4f5f6"
                />
            </g>
        </SVGIcon>
    );
}
